import classNames from 'classnames'
import { FC } from 'react'
import cn from './index.module.css'
import CatalogCoursesTab from '../CatalogCoursesTab/CatalogCoursesTab'
import CatalogHeader from '@pages/CoursesCatalog/components/CatalogHeader/CatalogHeader'

interface IUnauthorizedCatalog {}

const UnauthorizedCatalog: FC<IUnauthorizedCatalog> = ({}) => {
  return (
    <main className={cn.page}>
      <CatalogHeader className={cn.header} />
      <CatalogCoursesTab />
    </main>
  )
}

export default UnauthorizedCatalog
